const Vr6 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-6/PNG%20n.3/3d%206-3/publish%206-3/`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 6 Tour"
        ></iframe>
      </div>
    );
};

export default Vr6;
